// Display order for the per-hospital module toggles, shared by the two platform
// admin screens. It used to be copy-pasted into both, which meant a new module
// key added to the backend could end up with no toggle on one of them — the
// worst failure mode, since the module is then enabled with no way to turn it off.
//
// This is ORDERING only, not a registry: the backend's RX_MODULE_DEFAULTS is the
// source of truth, and both screens render any key it returns that isn't listed
// here after the ordered ones. Labels also come from the backend.
export const MODULE_ORDER = [
  "queue",
  "prescriptions",
  "medical_certificates",
  "dental",
  "inventory",
  "pharmacy_pos",
  "doctor_business_dashboard",
  "calendar_reservations",
  "qr_payment_upload",
  "patient_qr_card",
  "patient_access_control",
];

export const CLINIC_TYPES = [
  { value: "medical", label: "Medical" },
  { value: "dental", label: "Dental" },
];
